module.exports = __webpack_public_path__ + "img/ehda.be26598f.png";